import React from 'react';

// lucide-react n'a pas d'icône TikTok : on reproduit le pictogramme de la marque
// avec la même API que les icônes lucide (size, color via currentColor).
const TikTokIcon = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.6 5.82c-1.02-.9-1.6-2.2-1.6-3.62h-3.16v13.32c0 1.6-1.3 2.9-2.9 2.9a2.9 2.9 0 0 1-2.9-2.9 2.9 2.9 0 0 1 2.9-2.9c.3 0 .6.05.87.13V9.6a6.06 6.06 0 0 0-.87-.06 6.06 6.06 0 0 0-6.06 6.06A6.06 6.06 0 0 0 8.94 21.66a6.06 6.06 0 0 0 6.06-6.06V8.79a8.16 8.16 0 0 0 4.76 1.52V7.15a4.85 4.85 0 0 1-3.16-1.33Z" />
  </svg>
);

export default TikTokIcon;
